module.exports = __webpack_public_path__ + "img/children-3.4bf9fe56.jpg";